"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.objStrRegex = exports.jsonpRegex = void 0;
var interface_utils_1 = require("@uip-alpha/interface-utils");
var shared_utils_1 = require("@uip-alpha/shared-utils");
/**
 * 配置文件需要符合下列正则格式，wrapper local_或region_
 */
exports.jsonpRegex = /^(local_[a-z_A-Z]*|region_[a-z_A-Z]*)\((\{[\s\S]*\}|\[[\s\S]*\])?\)[\n\s\t]*$/;
exports.objStrRegex = /^(\{[\s\S]*\}|\[[\s\S]*\])[\n\s]*$/;
exports.init = function (configs) { return function (UIP) {
    var http = interface_utils_1.shallowClone(UIP.http);
    var map = new WeakMap();
    /** 单独设置环境变量并覆盖 */
    if (configs && configs.mode) {
        http._env = configs.mode;
        delete configs.mode;
    }
    /**
     * 修改http request方法(对应get，post，jsonp都会更改)
     * 统一优化请求方法，比如缓存请求(防止重复提交)
     *  */
    http.request = function (conf) {
        /** 防重复提交 */
        if (map.has(conf))
            return map.get(conf);
        var promise = UIP.http
            .request(__assign({ headers: configs }, conf))
            .then(function (res) {
            /** 此模块涉及到一直读内存缓存，则不删除 */
            // map.delete(conf)
            if (!res)
                return res;
            if (typeof res.data !== 'string')
                return res.data;
            // 处理小程序jsonp正则wrapper
            var formatResp = res.data.replace(exports.jsonpRegex, function (src, dest1, dest2) { return dest2; });
            return exports.objStrRegex.test(formatResp) ? shared_utils_1.parse(formatResp) : formatResp;
        })
            .catch(function (e) {
            map.delete(conf);
            console.error(e);
            return Promise.resolve();
        });
        map.set(conf, promise);
        return promise;
    };
    return http;
}; };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-assets/dist/common/init.js
// module id = P8ZO
// module chunks = 1